const locale = {
    placeholder: 'Избор на час',
    rangePlaceholder: ['Начален час', 'Краен час'],
};
export default locale;
